const global = window;
import Swiper from 'swiper';
if (global) global.Swiper = Swiper
